module.exports = __webpack_public_path__ + "media/ets/electric_bg_3-9b3738f6.png";